import React, { useState, useEffect } from "react";
import AveragePriceContainer from "./AveragePriceContainer";
import { avg as averageFn } from "../../../utils/helper/calcAverage";
import AreaChartComponent from "../../atoms/AreaChart";
import { Select } from "antd";
import { getGraphData } from "../../../utils/API/getGraphData";
import { Skeleton } from "antd";
import getSymbolFromCurrency from "currency-symbol-map";
import { useDispatch } from "react-redux";

function getKey(filter) {
  if (filter === "weekly") {
    return "week";
  } else if (filter === "yearly") {
    return "year";
  } else {
    return "month";
  }
}

const AveragePriceChart = () => {
  const dispatch = useDispatch();
  const [graphData, setGraphData] = useState([]);
  const [filter, setFilter] = useState("yearly");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { goldAvg, silverAvg, bronzeAvg } = averageFn(graphData);
  useEffect(() => {
    setLoading(true);
    getGraphData(filter, dispatch)
      .then((data) => {
        setGraphData(data);
      })
      .catch((err) => setError(err.message))
      .finally(() => {
        setLoading(false);
      });
  }, [filter]);
  if (error)
    return (
      <div className="w-full shadow-custom bg-white p-4 pt-6 rounded-2xl h-[25rem] flex justify-center items-center">
        {error}
      </div>
    );
  return (
    <div className="w-full shadow-custom bg-white p-4 pt-6 rounded-2xl">
      <div className="px-6 w-full flex justify-between mb-6">
        <h3 className="text-xl font-medium">Average Price</h3>

        <Select
          className="graph-selector w-24"
          value={filter}
          onChange={(value) => {
            setFilter(value);
          }}
          options={[
            {
              value: "yearly",
              label: "Yearly",
            },
            {
              value: "monthly",
              label: "Monthly",
            },

            {
              value: "weekly",
              label: "Weekly",
            },
          ]}
        />
      </div>
      <div className="flex flex-row-reverse gap-6">
        <div className="flex flex-col gap-y-8 justify-center w-fit shrink-0 grow-0">
          <AveragePriceContainer varient="gold">
            {getSymbolFromCurrency("USD")} {goldAvg}
          </AveragePriceContainer>

          <AveragePriceContainer varient="silver">
            {getSymbolFromCurrency("USD")} {silverAvg}
          </AveragePriceContainer>

          <AveragePriceContainer varient="bronze">
            {getSymbolFromCurrency("USD")} {bronzeAvg}
          </AveragePriceContainer>
        </div>
        {loading ? (
          <div className="w-full p-4">
            <Skeleton.Button
              block={true}
              active={true}
              style={{ height: "16.7rem", width: "100%" }}
            />
          </div>
        ) : (
          <AreaChartComponent filter={getKey(filter)} data={graphData} />
        )}
      </div>
    </div>
  );
};

export default AveragePriceChart;
